import { RpcAzureOperation, RpcAzureOperationResult } from './rpc-azure-model';

/**
 * Rpc azure sever side handler interface.
 */
export interface RpcAzureRequestHandler {
    handler(data: RpcAzureOperation): Promise<RpcAzureOperationResult>;
}
